import { viewPaths } from '@better-auth-ui/core'
import { Settings } from '@better-auth-ui/heroui'
import { createFileRoute, notFound, redirect } from '@tanstack/react-router'

import { PublicLayout } from '~/components/layout/public-layout'
import { AccountDeletionPanel } from '~/features/compliance/account-deletion-panel'
import { EmailVerificationBanner } from '~/features/compliance/email-verification-banner'
import { authRecoveryHref } from '~/lib/auth/redirect'
import { createSessionQuery } from '~/lib/session-query'

export const Route = createFileRoute('/settings/$pathname')({
  beforeLoad: async ({ context, location, params: { pathname } }) => {
    if (!Object.values(viewPaths.settings).includes(pathname)) {
      throw notFound()
    }

    const session = await context.queryClient.ensureQueryData(
      createSessionQuery(context.queryClient),
    )

    if (!session?.session) {
      throw redirect({
        href: authRecoveryHref(location),
        replace: true,
      })
    }

    return { session, user: session.user }
  },
  component: SettingsPage,
})

function SettingsPage() {
  const { pathname } = Route.useParams()
  const { user } = Route.useRouteContext()

  return (
    <PublicLayout>
      {!user.emailVerified && <EmailVerificationBanner email={user.email} />}
      <div className="mx-auto w-full max-w-4xl px-4 py-10 lg:px-6">
        <Settings path={pathname} />
        {pathname === 'security' && <AccountDeletionPanel />}
      </div>
    </PublicLayout>
  )
}
